
/* injects from baggage-loader */

'use strict';

export default class AccountActivityController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

		/*
				Activity feed data
					- What (Show icon for each event or badge tag)
						- Product accessed						[product-access]
						- Document downloaded					[document-download]
						- Document access requested		[document-request]
						- Service requested						[service-request]
					- Where (geo ip)
						- Country
						- State
						- City
						- Approximate GPS location (from IP)
					- Who
						- IP address (or display "Annonymous")
						- Name of person if unique access key used
					- When
						- Timestamp of record

		*/

	}

	$onInit() {

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/account/activity/account.activity.controller.js